import {useAppDispatch, useAppSelector} from "../../../redux/store";
import {selectCategoryFood} from "../../../common/selectors";
import {BlockTwoSettings} from "./blockTwoSettings";
import {useEffect} from "react";
import {fetchSkuFoodSvTableTC, fetchSkuFoodTotalTC} from "../../../redux/categoryFoodReducer";
import {LineChartCatFoodBlockTwo} from "./lineChartCatFoodBlockTwo";
import {ColumnChartCatFoodBlockTwo} from "./columnChartCatFoodBlockTwo";

// Компонент DashboardBlockTwo отвечает за отображение второго блока аналитики по категориям продуктов
export const DashboardBlockTwo = () => {

    // Инициализация dispatch для отправки экшенов в Redux
    const dispatch = useAppDispatch()

    // Получение данных из Redux store: фильтры и данные для графиков
    const {dateSvTable, citySvTable, store_nameSvTable, dataSvTable, categoryTotalForBlockTwo} = useAppSelector(selectCategoryFood)


    // Эффект: при изменении фильтров запрашиваем новые данные для графиков и информации
    useEffect(() => {
        // Запрос данных для таблицы уникальных товаров по неделям
        dispatch(fetchSkuFoodSvTableTC({
            start_date_from: dateSvTable[0],
            end_date_to: dateSvTable[1],
            city: citySvTable,
            store_name: store_nameSvTable,

        }))
        // Запрос итоговых данных (например, средняя цена) для второго блока
        dispatch(fetchSkuFoodTotalTC({
            city: citySvTable,
            store_name: '',
            start_date_from: dateSvTable[0],
            end_date_to: dateSvTable[1],
            address: 'Средняя цена',
            block: 'two'
        }))
    }, [dateSvTable, citySvTable, store_nameSvTable]);

    // Отрисовка блока настроек и графиков
    return (
        <div>
            {/* Компонент настроек фильтров для блока 2 */}
            <BlockTwoSettings date={dateSvTable} city={citySvTable} store_name={store_nameSvTable}/>
            {/* График по уникальным товарам (столбчатая диаграмма) */}
            {dataSvTable && <ColumnChartCatFoodBlockTwo data={dataSvTable}/>}
            {/* График по итоговым данным (линейная диаграмма) */}
            {categoryTotalForBlockTwo && <LineChartCatFoodBlockTwo data={categoryTotalForBlockTwo} time={dateSvTable}/>}
        </div>
    );
};
